module.exports = __webpack_public_path__ + "img/ribbon.5a85c707.svg";